import playgroundSbtApiDefinition from './api/index.js';
import playgroundSbtAtomDefinition from './atoms/index.js';
import playgroundSbtModuleDefinition from './module/index.js';
import playgroundSbtPluginDefinition from './plugin/index.js';

interface Options {
  config?: { baseUrl: string };
}

const DEFAULT_CONFIG = { baseUrl: 'https://minze.a.exodus.io' };

const playgroundSbt = ({ config = DEFAULT_CONFIG }: Options = {}) => {
  return {
    id: 'playgroundSbt',
    definitions: [
      { definition: playgroundSbtAtomDefinition },
      { definition: playgroundSbtPluginDefinition },
      { definition: playgroundSbtApiDefinition },
      { definition: playgroundSbtModuleDefinition, config },
    ],
  };
};

export default playgroundSbt;
